export default __webpack_public_path__ + "static/Continuous Integration 6-6c64f13d3b8dd24c2ab116da8377528a.png";